import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../services/auth';
import { LogOut } from 'lucide-react';

interface MobileHeaderProps {
  user: User | null;
  onLogout: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ user, onLogout }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowMenu(false);
    if (window.confirm(`Are you sure you want to logout${user?.name ? `, ${user.name}` : ''}?`)) {
      onLogout();
      navigate('/');
    }
  };

  const getInitials = (name?: string) => {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-[100] md:hidden shadow-sm" style={{ paddingTop: 'max(16px, env(safe-area-inset-top, 0px))' }}>
      <div className="flex items-center justify-between px-4 py-3 h-16 max-w-full overflow-hidden">
        <img 
          src="/HGI-icon.png" 
          alt="HomeGrowInvest" 
          className="h-10 w-auto max-w-[120px] object-contain"
        />
        {user && (
          <div className="relative">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="w-10 h-10 rounded-full bg-primary-600 text-white font-bold flex items-center justify-center border-2 border-primary-200 hover:bg-primary-700 transition-colors"
            >
              {getInitials(user.name)}
            </button>
            
            {showMenu && (
              <>
                <div 
                  className="fixed inset-0 z-40"
                  onClick={() => setShowMenu(false)}
                />
                <div className="absolute right-0 top-12 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-3 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Logout</span>
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default MobileHeader;

